/**
 * LeadCard — um card do board (.kanban__card). Draggable (HTML5 nativo,
 * mesma mecanica do Kanbans/Board.jsx).
 *
 * Conteudo (item 10) — enxuto, focado no que o vendedor precisa de relance:
 *   - nome do cliente/contato em DESTAQUE (.card-title)
 *   - descricao do negocio (lead.titulo), secundaria
 *   - rodape: [codigo do lead + data de chegada no CRM] a esquerda,
 *     inicial do vendedor (.avatar-tiny) a direita
 *
 * Removidos do card: valor estimado e tempo relativo (ruido visual). Click
 * abre o cockpit (onAbrir). Drag desabilitado quando `podeMover` e falso.
 */
import React from "react";

import UserAvatar from "../../components/UserAvatar";
import { fmtData } from "../Orcamentos/helpers";

function LeadCard({
  lead,
  podeMover,
  dragging,
  onAbrir,
  onDragStart,
  onDragEnd,
}) {
  // R21: prioriza o nome do CONTATO do lead (campo "Nome" editavel no cockpit,
  // em DadosLeadBlock). Antes priorizava `cliente_nome`, entao ao renomear o
  // contato de um lead com cliente vinculado o card seguia mostrando o nome do
  // cliente — dando a impressao de que a renomeacao "nao pega". `cliente_nome`
  // vira fallback para leads sem dados de contato proprios.
  // Nome completo em DESTAQUE + apelido como subtitulo logo abaixo (antes os
  // dois vinham concatenados numa linha so). Fallback p/ cliente vinculado
  // quando o lead nao tem dados de contato proprios.
  const nomeCompleto = lead.contato_nome || lead.cliente_nome || "Sem cliente";
  const apelido = (lead.contato_sobrenome || "").trim();
  const nomeResponsavel = lead.responsavel_nome || nomeCompleto;

  return (
    <div
      className="kanban__card"
      draggable={podeMover}
      onDragStart={(e) => onDragStart(e, lead)}
      onDragEnd={onDragEnd}
      onClick={() => onAbrir(lead)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onAbrir(lead);
        }
      }}
      role="button"
      tabIndex={0}
      style={dragging ? { opacity: 0.5 } : undefined}
      title={podeMover ? "Clique para abrir; arraste para mover" : "Clique para abrir"}
    >
      <div className="card-title" title={nomeCompleto}>
        {nomeCompleto}
        {lead.arquivado && (
          <span className="badge neutral no-dot" style={{ marginLeft: 8 }}>
            Arquivado
          </span>
        )}
      </div>

      {apelido && (
        <div className="card-apelido" title={apelido}>
          {apelido}
        </div>
      )}

      {lead.titulo && (
        <div
          className="card-meta"
          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          title={lead.titulo}
        >
          {lead.titulo}
        </div>
      )}

      <div className="card-foot">
        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
          <span className="card-id">{lead.numero}</span>
          <span className="mono" style={{ fontSize: 11, color: "var(--ink-3)" }}>
            {fmtData(lead.created_at)}
          </span>
        </div>
        <UserAvatar
          src={lead.responsavel_foto_url}
          nome={nomeResponsavel}
          size="xs"
        />
      </div>
    </div>
  );
}

export default LeadCard;
